<template>
  <el-dialog
      :model-value="props.visible"
      title="修改密码"
      width="600"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">

      <div class="tip-txt">
        您的密码过于简单，请修改复杂密码后再登录系统！
      </div>

      <el-form ref="pwdRef" :model="formData" :rules="rules" label-width="80px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="formData.oldPassword" placeholder="请输入旧密码" type="password" show-password/>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="formData.newPassword" placeholder="请输入新密码" type="password" show-password/>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="formData.confirmPassword" placeholder="请确认新密码" type="password" show-password/>
        </el-form-item>

      </el-form>

      <div class="my-footer">
        <!--        <el-button @click="emit('update:visible', false)">取消</el-button>-->
        <el-button type="primary" style="margin-right: 15px;" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";
import {updateLoginUserPwd} from "@/api/system/user";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  accessToken: {
    type: String,
    default: ''
  }
})

const equalToPassword = (rule, value, callback) => {
  if (formData.value.newPassword !== value) {
    callback(new Error("两次输入的密码不一致"));
  } else {
    callback();
  }
};

const pageLoading = ref(false)
const formData = ref({})
const rules = reactive({
  oldPassword: [{required: true, message: "旧密码不能为空", trigger: "blur"}],
  newPassword: [{required: true, message: "新密码不能为空", trigger: "blur"},
    {min: 8, max: 20, message: "长度在 8 到 20 个字符", trigger: "blur"},
    {
      pattern: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[~!#@$%^*&()_+{}\[\]|\\;:'",<.>\/?])[a-zA-Z\d~!#@$%^*&()_+{}\[\]|\\;:'",<.>\/?]*$/,
      message: "密码必须包含（大写字母、小写字母、数字、特殊字符）", trigger: "blur"
    }
  ],

  confirmPassword: [
    {required: true, message: "确认密码不能为空", trigger: "blur"},
    {required: true, validator: equalToPassword, trigger: "blur"}
  ]
})

function onOpen() {
}

const pwdRef = ref()

const emit = defineEmits(['update:visible', 'refresh'])

async function onConfirm() {
  await pwdRef.value.validate(valid => {
    if (valid) {
      pageLoading.value = true
      updateLoginUserPwd(formData.value.oldPassword, formData.value.newPassword, 'Bearer ' + props.accessToken)
          .then(res => {
            if (res.code === 200) {
              emit('update:visible', false)
              ElMessageBox.alert('修改成功，请使用新密码重新登录!', '提示', {
                confirmButtonText: '确定',
                callback: () => {

                }
              })
            }
          })
          .finally(() => {
            pageLoading.value = false
          })
    }
  })
}

function closedModal() {
  emit('update:visible', false)
  formData.value = {}
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}

.tip-txt {
  padding-left: 15px;
  padding-bottom: 20px;
  color: #606266;
  font-size: 16px;
  font-weight: 700;
}
</style>
